// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { FeatureTypeDefinition } from "./FeatureTypeDefinition";
import {
  FeatureTypeDefinitionFromJSON,
  FeatureTypeDefinitionFromJSONTyped,
  FeatureTypeDefinitionToJSON,
  FeatureTypeDefinitionToJSONTyped,
} from "./FeatureTypeDefinition";
import type { SpatialExtent } from "./SpatialExtent";
import {
  SpatialExtentFromJSON,
  SpatialExtentFromJSONTyped,
  SpatialExtentToJSON,
  SpatialExtentToJSONTyped,
} from "./SpatialExtent";
import type { SchematisationVectorLayer } from "./SchematisationVectorLayer";
import {
  SchematisationVectorLayerFromJSON,
  SchematisationVectorLayerFromJSONTyped,
  SchematisationVectorLayerToJSON,
  SchematisationVectorLayerToJSONTyped,
} from "./SchematisationVectorLayer";

/**
 *
 * @export
 * @interface SchematisationVectorMeta
 */
export interface SchematisationVectorMeta {
  /**
   * A spatial bounding box of 4 floats (x1, y1, x2, y2). For WGS84 we use traditional (x=lon, y=lat) order.
   */
  envelope: Array<number>;
  /**
   *
   */
  extent: SpatialExtent;
  /**
   *
   */
  layers: Array<SchematisationVectorLayer>;
  /**
   *
   */
  featureTypeDefinition?: FeatureTypeDefinition;
}

/**
 * Check if a given object implements the SchematisationVectorMeta interface.
 */
export function instanceOfSchematisationVectorMeta(
  value: object
): value is SchematisationVectorMeta {
  if (!("envelope" in value) || value["envelope"] === undefined) return false;
  if (!("extent" in value) || value["extent"] === undefined) return false;
  if (!("layers" in value) || value["layers"] === undefined) return false;
  return true;
}

export function SchematisationVectorMetaFromJSON(json: any): SchematisationVectorMeta {
  return SchematisationVectorMetaFromJSONTyped(json, false);
}

export function SchematisationVectorMetaFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SchematisationVectorMeta {
  if (json == null) {
    return json;
  }
  return {
    envelope: json["envelope"],
    extent: SpatialExtentFromJSON(json["extent"]),
    layers: (json["layers"] as Array<any>).map(SchematisationVectorLayerFromJSON),
    featureTypeDefinition:
      json["feature_type_definition"] == null
        ? undefined
        : FeatureTypeDefinitionFromJSON(json["feature_type_definition"]),
  };
}

export function SchematisationVectorMetaToJSON(json: any): SchematisationVectorMeta {
  return SchematisationVectorMetaToJSONTyped(json, false);
}

export function SchematisationVectorMetaToJSONTyped(
  value?: SchematisationVectorMeta | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    envelope: value["envelope"],
    extent: SpatialExtentToJSON(value["extent"]),
    layers: (value["layers"] as Array<any>).map(SchematisationVectorLayerToJSON),
    feature_type_definition: FeatureTypeDefinitionToJSON(value["featureTypeDefinition"]),
  };
}
